import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject, Subscription } from 'rxjs';
import { DatasetService } from './dataset.service';
import { Router } from '@angular/router';
import { DatasetActionContainerService } from './datasetACS';
import { AppService } from './app.service';
import { HttpClient } from '@angular/common/http';

export interface ICartData{
	actual_trip_id?: any;
	contextual_domain_id?: any;
	date: any;
	display_name_item?: string;
	lang?: string;
	master_image?: any;
	participants: any;
	return_trip_id?: any;
	target?: string;
	total?: any;
	trip_package_id?: any;
	product_id?: any;
	variation_name_item?: any;
}

@Injectable()
export class CartService{

	private cartTiemout: any;
	private subscription: Subscription;

	public showGenericErrorCoupon: boolean;
	public timeExpired: boolean;
	public loading: BehaviorSubject<boolean>;
	public addToCartLoading: BehaviorSubject<boolean>;
	public cartData: BehaviorSubject<any>;

	constructor(
		public appService: AppService,
		public datasetACS: DatasetActionContainerService,
		public datasetService: DatasetService, 
		private http: HttpClient,
		private router: Router){
		this.loading = new BehaviorSubject<boolean>(false);
		this.addToCartLoading = new BehaviorSubject<boolean>(false);
		this.cartData = new BehaviorSubject<any>(null);
	}

	makeCall(method: Observable<any>, withSubscription: boolean = false): Observable<any>{
		const result = new Subject();
		this.loading.next(true);
		if (withSubscription && this.subscription && !this.subscription.closed){
			this.subscription.unsubscribe();
		}
		this.subscription = method.subscribe({
			next: (response) => {
				this.setInternalTimer(response);
				this.cartData.next(response);
				result.next(response);
				this.loading.next(false);
				result.complete();
			},
			error: (response) => {
				this.appService.showSnackbarMessage();
				this.appService.snackbarText = response?.error?.message || 'Error http call';
				this.loading.next(false);
				this.datasetACS.loading.next(false);
				this.addToCartLoading.next(false);
			}
		});
		return result;
	}

	setInternalTimer(cartData: any): void{
		if (this.cartTiemout){
			clearTimeout(this.cartTiemout);
		}
		if (cartData.num_items){
			this.timeExpired = false;
			if (cartData.expire_timeout === 'is_expired') {
				this.timeExpired = true;
				this.deleteCart();
			}
			if (!this.timeExpired){
				const milliseconds = parseInt(cartData.expire_timeout, 0);
				this.cartTiemout = setTimeout(() => {
					this.timeExpired = true;
					this.deleteCart();
				}, milliseconds);
			}
		}
	}

	addToCart(cartData: ICartData): void{
		this.addToCartLoading.next(true);
		this.makeCall(this.datasetService.post('/cart/add-to-cart', cartData))
		.subscribe(() => {
			this.addToCartLoading.next(false);
			this.router.navigate(['/d', this.appService.domainId, 'cart']);
		});
	}

	updateCart(cartItem: any, data: any){
		this.addToCartLoading.next(true);
		this.makeCall(this.datasetService.post('/cart/update-cart/' + cartItem.id, data))
		.subscribe(() => {
			this.addToCartLoading.next(false);
			this.router.navigate(['/d', this.appService.domainId, 'cart']);
		});
	}

	getCart(): Observable<any>{
		return this.makeCall(this.datasetService.get('/cart/get-cart'), true);
	}

	removeItem(id: any): Observable<any>{
		return this.makeCall(this.datasetService.post('/cart/remove-item/' + id));
	}

	clearCart(): Observable<any>{
		return this.makeCall(this.datasetService.post('/cart/clear'));
	}
	
	deleteCart(): Observable<any>{
		return this.makeCall(this.datasetService.post('/cart/delete', {new_cart: true}));
	}

	applyCoupon(coupons: any): Observable<any>{
		const result = new Subject();
		this.loading.next(true);
		this.http.post(this.appService.getBaseServerAddress() + '/cart/apply-coupon', {
			coupons: coupons,
			trip_booking_ids: this.cartData.value.cart_items.map(item => item.trip_booking_id),
			target: 'product'
		}).subscribe({
			next: (response) => {
				this.loading.next(false);
				result.next(response);
				result.complete();
			},
			error: (response) => {
				this.showGenericErrorCoupon = true;
				setTimeout(() => this.showGenericErrorCoupon = false, 4000);
				this.loading.next(false);
			}
		});
		return result;
	}
}
